module.exports = __webpack_public_path__ + "static/img/6.5b272bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/6.png
// module id = oqrI
// module chunks = 0